import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { Price } from 'components/cart/Price';
import { type Ref } from 'react';
import type { Money } from 'types/product/Money';

import { ProductConfiguratorRadioButton } from '../ProductConfiguratorRender/ui/ProductConfiguratorRadioButton';

interface SkincareVariantRadioItemProps {
  label: string;
  netContents?: string;
  isSelected: boolean;
  price: Money | null;
  compareAtPrice?: Money | null;
  onClick: () => void;
  onMouseEnter?: () => void;
  ref?: Ref<HTMLDivElement>;
}

export const SkincareVariantRadioItem = ({
  label,
  netContents,
  isSelected,
  price,
  compareAtPrice,
  onClick,
  onMouseEnter,
  ref,
}: SkincareVariantRadioItemProps) => (
  <Box
    ref={ref}
    borderWidth={1}
    borderRadius="base"
    borderColor={isSelected ? 'gray.600' : 'blackAlpha.250'}
    cursor="pointer"
    role="radio"
    aria-checked={isSelected}
    tabIndex={isSelected ? 0 : -1}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onKeyDown={(event) => {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        onClick();
      }
    }}
  >
    <Flex
      as="span"
      sx={{
        '--dot-size': isSelected ? 'scale(1)' : 'scale(0)',
      }}
      _hover={{
        '--dot-size': isSelected ? 'scale(1)' : 'scale(0.5)',
      }}
      width="100%"
      alignItems="center"
      py="2xs"
      px="xs"
      minH={66}
      gap="2xs"
    >
      <ProductConfiguratorRadioButton isActive={isSelected} />
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        w="full"
      >
        <Stack spacing="5xl">
          <Text size="title2" textAlign="left" as="span">
            {label}
          </Text>
          {netContents && (
            <Text
              as="span"
              size="detail"
              fontWeight="book"
              color="blackAlpha.600"
            >
              {netContents}
            </Text>
          )}
        </Stack>
        {price && (
          <Price
            subtotalAmount={compareAtPrice}
            totalAmount={price}
            direction="row-reverse"
          />
        )}
      </Flex>
    </Flex>
  </Box>
);
